export const state = () => ({ categoryList: null, applicationsList: null, solutionCategoriesList: null });
